import { Hint, IHintConfig } from '../hint/Hint'
import PrebidFacade from '../prebidFacade/PrebidFacade'
import SlotFactory from '../slots/SlotFactory'

export class ListHints {
  private static SELECTOR = '.mv-create-list-target'
  private static SLOT_CLASS: SlotClass = 'Content'
  private hintConfig: IHintConfig

  constructor(prebidFacade: PrebidFacade, slotFactory: SlotFactory) {
    this.hintConfig = {
      desktopSelector: ListHints.SELECTOR,
      mobileSelector: ListHints.SELECTOR,
      prebidFacade,
      slotFactory,
      slot: ListHints.SLOT_CLASS
    }

    this.render()
  }

  render(): boolean {
    return Hint.addSlotsToHints(this.hintConfig)
  }
}
